export const DashboardSearchStructures = {
    project_recurring_aggregate: {
        search: [
            {
                operator_id: '=',
                field_id: 'recurring_frequency',
                display: '',
                value: 3
            }
        ],
        result_type: {
            bucket_time_frame: {
                type: 'bucket_time_frame'
            }
        },
        metadata: {
            company: null,
            created_by: null,
            simple_logic: 'and',
            modified_by: null,
            name: 'Recurring Projects',
            date_modified: null,
            next_criteria_id: 1,
            display_result_type: 'bucket_time_frame',
            id: null,
            version: 2,
            date_created: null,
            type: 'project_recurring_aggregate'
        }
    },
    project_list: {
        search: [],
        result_type: {
            list: {
                type: 'list'
            }
        },
        metadata: {
            company: null,
            created_by: null,
            simple_logic: 'and',
            modified_by: null,
            name: 'Project List',
            date_modified: null,
            next_criteria_id: 1,
            display_result_type: 'list',
            id: null,
            version: 1,
            date_created: null,
            type: 'project_list'
        }
    },
    forms_top_nos: {
        search: [],
        result_type: {
            bucket_time_frame: {
                type: 'bucket_time_frame'
            }
        },
        metadata: {
            company: null,
            created_by: null,
            simple_logic: 'and',
            modified_by: null,
            name: 'Frequently Answered "No"',
            date_modified: null,
            next_criteria_id: 1,
            display_result_type: 'bucket_time_frame',
            id: null,
            version: 2,
            date_created: null,
            type: 'forms_top_nos'
        }
    },
    tasks_current: {
        search: [],
        result_type: {
            list: {
                type: 'list'
            }
        },
        metadata: {
            company: null,
            created_by: null,
            simple_logic: 'and',
            modified_by: null,
            name: 'Current Team Tasks',
            date_modified: null,
            next_criteria_id: 1,
            display_result_type: 'list',
            id: null,
            version: 2,
            date_created: null,
            type: 'tasks_current'
        }
    },
    workflows_top_triggered: {
        search: [],
        result_type: {
            bucket_time_frame: {
                type: 'bucket_time_frame'
            }
        },
        metadata: {
            company: null,
            created_by: null,
            simple_logic: 'and',
            modified_by: null,
            name: 'Top Triggers',
            date_modified: null,
            next_criteria_id: 1,
            display_result_type: 'bucket_time_frame',
            id: null,
            version: 2,
            date_created: null,
            type: 'workflows_top_triggered'
        }
    },
    tasks_completion_rate: {
        search: [],
        result_type: {
            column: {
                type: 'column'
            }
        },
        metadata: {
            company: null,
            created_by: null,
            simple_logic: 'and',
            modified_by: null,
            name: 'Task Completion Rate',
            date_modified: null,
            next_criteria_id: 1,
            display_result_type: 'column',
            id: null,
            version: 2,
            date_created: null,
            type: 'tasks_completion_rate'
        }
    }
};
